// React Dependencies
import React from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Icon } from '@material-ui/core';

// Internal Dependencies
import Colours from '../../styles/colours';

const Filter = ({ fontSize = '2rem' }) => (<Icon style={{  fontSize }}>filter_list</Icon>);

Filter.propTypes = {
  fontSize: PropTypes.string,
};

Filter.defaultProps = {
  fontSize: '1.6rem',
};

const Impression = ({ colour, fontSize }) => (<Icon style={{ color: colour || Colours.Black, fontSize }}>crop_original</Icon>);

Impression.propTypes = {
  colour:   PropTypes.string,
  fontSize: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
};

Impression.defaultProps = {
  colour:   Colours.Black,
  fontSize: '1.6rem',
};

const Cross = ({ colour, fontSize }) => (<Icon style={{ color: colour || Colours.Black, fontSize }}>close</Icon>);

Cross.propTypes = {
  colour:   PropTypes.string,
  fontSize: PropTypes.string,
};

Cross.defaultProps = {
  colour:   Colours.Black,
  fontSize: '2rem',
};

const PhotoLocation = (props) => (
  <div
    className={props.className}
    style={{
      transform:       props.withShadow ? 'translate(-50%, -50%)' : 'none',
      transformOrigin: props.withShadow ? 'center center' : 'none',
      width:           props.size,
      height:          props.size,
      borderRadius:    props.size,
      borderWidth:     '4px',
      borderColor:     props.withShadow ? Colours.White : 'none',
      boxShadow:       props.withShadow ? '0 0 20px rgba(0, 0, 0, 0.6)' : 'none',
      backgroundColor: Colours.OrangePoiMarker,
      ...props.style,
    }}
  />
);

PhotoLocation.propTypes = {
  className:  PropTypes.string,
  style:      PropTypes.shape({}),
  size:       PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // Adjusted to oneOfType for validation
  withShadow: PropTypes.bool,
};

PhotoLocation.defaultProps = {
  className:  '',
  style:      {},
  size:       '15px',
  withShadow: false,
};

const Icons = {
  Filter,
  Impression,
  Cross,
  PhotoLocation,
};

export default Icons;
